import React from 'react'
import { ErrorStyles, FabButtonStyles } from '../Style'
import { AnimatePresence } from "motion/react"
import { IconButton, SvgIcon } from '@mui/material'
import { ReactComponent as RefreshPermissionIcon } from 'assets/icons/RefreshPermission.svg';
import { Img } from 'styles/GlobalStyle'
import { NoPermission_Go } from 'assets'
import * as motion from "motion/react-client"

const NoPermissions = (props) => {
    const { checkAgain, isTeacherCheck } = props

    if (isTeacherCheck) {
        return (
            <AnimatePresence>
                <motion.div
                    exit={{ opacity: 0 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.7 }}
                    key="no-permission-teacher"
                >
                    <div className='teacher-texts'>
                        <div className='text-group'>
                            <div className='title'>{"המיקרופון לא מאופשר"}</div>
                            <div className='text'>
                                {"יש לאפשר שימוש במיקרופון"}
                                <br />
                                {"בחלק העליון בצד ימין."}
                            </div>
                            <div className='text'>
                                {"לאחר האישור,"}
                                <br />
                                {"לחצי על הכפתור לבדיקה חוזרת"}
                            </div>
                        </div>
                        <div className='refresh-btn' onClick={checkAgain}>
                            <SvgIcon component={RefreshPermissionIcon} inheritViewBox />
                        </div>
                    </div>
                    <Img className="cartoon-corner" style={{ height: 202 }} src={NoPermission_Go} />
                </motion.div>
            </AnimatePresence>
        )
    }

    return (
        <>
            <motion.div
                exit={{ opacity: 0 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.7 }}
                key="error-mic"
            >
                <ErrorStyles>
                    <div className='title'>{"המיקרופון לא מאופשר"}</div>
                    <div className='text'>
                        <div>{"יש לאפשר שימוש במיקרופון"}</div>
                        <div>{"בחלק העליון בצד ימין."}</div>
                    </div>
                    <div className='text'>
                        <div>{"לאחר האישור,"}</div>
                        <div>{"לחצי על הכפתור לבדיקה חוזרת"}</div>
                    </div>
                    <div className='refresh-check-permissions-img'>
                        <div className='wrap-fab-button'>
                            <FabButtonStyles onClick={checkAgain}>
                                <IconButton onClick={() => { }}>
                                    <SvgIcon fontSize='small' component={RefreshPermissionIcon} inheritViewBox />
                                </IconButton>
                            </FabButtonStyles>
                        </div>

                        <div className='side-cartoon'>
                            <Img src={NoPermission_Go} />
                        </div>
                    </div>
                </ErrorStyles>
            </motion.div>
        </>
    )
}

export default NoPermissions